import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");

  usePageMeta(
    "页面不存在 - 漂亮的保姆",
    "抱歉，你访问的页面不存在。可以返回首页，或使用搜索查找你想看的影视剧资讯与剧情介绍。",
    "漂亮的保姆,404,页面不存在",
  );

  function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    const kw = keyword.trim();
    navigate(kw ? `/search?q=${encodeURIComponent(kw)}` : "/search");
  }

  return (
    <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-16 md:py-24">
      <div className="flex flex-col items-center text-center">
        <div className="font-heading text-[80px] md:text-[120px] leading-none font-bold text-primary-100 select-none">
          404
        </div>
        <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 -mt-4 md:-mt-6">
          页面不存在
        </h1>
        <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg">
          你访问的页面可能已被移动或删除。别急，你可以返回首页，或直接搜索想看的剧集与演员。
        </p>

        <form onSubmit={onSubmit} className="flex flex-col sm:flex-row gap-3 mt-6 w-full max-w-lg">
          <div className="relative flex-1">
            <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400" />
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索剧集、演员…"
              aria-label="搜索剧集或演员"
              className="w-full h-11 pl-11 pr-4 text-sm rounded-md bg-background-50 border border-background-200 focus:border-primary-400 focus:outline-none text-foreground-900 placeholder:text-foreground-400"
            />
          </div>
          <button
            type="submit"
            className="h-11 px-6 rounded-md bg-primary-600 text-background-50 text-sm font-medium hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            搜索
          </button>
        </form>

        <div className="flex flex-wrap items-center justify-center gap-3 mt-6">
          <Link
            to="/"
            className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-5-line" />
            返回首页
          </Link>
          <Link
            to="/news"
            className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-background-50 border border-background-300 text-foreground-700 text-sm font-medium hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-newspaper-line" />
            浏览影视资讯
          </Link>
        </div>

        <div className="mt-10 w-full">
          <p className="text-sm text-foreground-400 mb-3">或者从这些分类开始逛：</p>
          <div className="flex flex-wrap items-center justify-center gap-2">
            {categories.map((c) => (
              <Link
                key={c.type}
                to={`/category/${c.type}`}
                className="flex items-center gap-1.5 px-3.5 py-1.5 rounded-full bg-background-50 border border-background-200 text-sm text-foreground-600 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer"
              >
                <i className={c.icon} />
                {c.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}